<template>
  <div class="admin-layout">
    <aside class="admin-sidebar" :class="{ collapsed: !sidebarOpen }">
      <div class="logo">
        <span v-if="sidebarOpen">Thanh Danh</span>
        <button @click="sidebarOpen = !sidebarOpen">
          {{ sidebarOpen ? "«" : "»" }}
        </button>
      </div>

      <nav>
        <router-link
          class="router-link-"
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          :class="{ active: $route.path === item.path }"
        >
          <span class="icon">{{ item.icon }}</span>
          <span v-if="sidebarOpen">{{ item.title }}</span>
        </router-link>
        <a @click.prevent="logout()" class="btn btn-logout"
          ><i class="fas fa-sign-out-alt"></i> Đăng xuất
        </a>
      </nav>
    </aside>

    <div class="admin-main">
      <!-- <header class="admin-header">
        <h2>Admin</h2>
        <button class="logout-btn" @click="logout()">Đăng xuất</button>
      </header> -->

      <main class="admin-content">
        <router-view />
      </main>
    </div>
  </div>

  
</template>
<script setup>
import { useAuth } from "@/composables/useAuth";
import { ref } from "vue";

const sidebarOpen = ref(true);

const menuItems = ref([
  { title: "Dashboard", icon: "🏠", path: "/admin/dashboard.html" },
  { title: "Sản phẩm lên kệ", icon: "📦", path: "/admin/products.html" },
  {
    title: "Kho kĩ thuật",
    icon: "📦",
    path: "/admin/technical-stock.html",
  },
  {
    title: "Phiếu xuất kho",
    icon: "📤",
    path: "/admin/export-receipts.html",
  },
  { title: "Đơn hàng", icon: "📑", path: "/admin/orders.html" },
  { title: "Khách hàng", icon: "👥", path: "/admin/customers.html" },
  { title: "Nhà cung cấp", icon: "👥", path: "/admin/suppliers.html" },
  { title: "Thống kê", icon: "📊", path: "/admin/statistics.html" },
  { title: "Tài khoản", icon: "👤", path: "/admin/accounts.html" },
  { title: "Cài đặt", icon: "⚙️", path: "/admin/setting.html" },
]);
const {logout: logoutAuth} = useAuth();

const logout = ()=>{
  logoutAuth();
}
  
// export default {
//   data() {
//     return {
//       sidebarOpen: true,
//       warehouseOpen: false,
//       menuItems: [
//         { title: "Dashboard", icon: "🏠", path: "/admin/dashboard.html" },
//         { title: "Sản phẩm lên kệ", icon: "📦", path: "/admin/products.html" },
//         {
//           title: "Kho kĩ thuật",
//           icon: "📦",
//           path: "/admin/technical-stock.html",
//         },
//         {
//           title: "Phiếu xuất kho",
//           icon: "📤",
//           path: "/admin/export-receipts.html",
//         },
//         { title: "Đơn hàng", icon: "📑", path: "/admin/orders.html" },
//         { title: "Khách hàng", icon: "👥", path: "/admin/customers.html" },
//         { title: "Nhà cung cấp", icon: "👥", path: "/admin/suppliers.html" },
//         { title: "Thống kê", icon: "📊", path: "/admin/statistics.html" },
//         { title: "Tài khoản", icon: "👤", path: "/admin/accounts.html" },
//         { title: "Cài đặt", icon: "⚙️", path: "/admin/setting.html" },
//       ],
//     };
//   },

//   methods: {
//     logout() {
//       adminApi.logout().then(() => {
//         localStorage.removeItem("admin_token");
//         this.$router.push("/login-admin.html");
//       });
//     },
//   },
// };
</script>
<style scoped>
@import "@/assets/css/admin.css";

main {
  max-width: 100%;
  margin: 0;
}
</style>
